import { render, staticRenderFns } from "./IconRight.vue?vue&type=template&id=c668a176&"
import script from "./IconRight.vue?vue&type=script&lang=ts&"
export * from "./IconRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports